import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAdmin } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) { navigate("/admin/login"); return; }

    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setAdmin(res.data.admin);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { admin: res.data.admin } });
      } catch (e) {
        setError(e.response?.data?.detail || "This Google account is not authorized for the AAWTA admin dashboard.");
      }
    })();
  }, [navigate, setAdmin]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-8 max-w-md text-center shadow-xl">
        {error ? (
          <>
            <h1 className="font-display text-xl font-bold text-navy">Access Denied</h1>
            <p className="mt-3 text-sm text-dark-text/70">{error}</p>
            <button onClick={() => navigate("/admin/login")} className="mt-5 bg-magenta text-white font-bold py-2.5 px-6 rounded-md">Back to Login</button>
          </>
        ) : (
          <p className="font-display font-bold text-navy animate-pulse">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
